<template>
    <div id="main" class="select-modal">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">{{ $t('produto') }}:</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ $t('promotor') }}</a>
                            </li>
                            <li>
                                <a class="a-inativo">{{ $t('cadastros') }}</a>
                            </li>
                            <li>
                                <a @click="$router.push({ name: 'pro-produto-list' })">{{
                                    $t('produtos')
                                }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{
                                    !produto.idproproduto ? $t('adicionar-produto') : title
                                }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" @click="redirectToPage">
                        {{ $t('voltar') }}
                    </button>
                    <button
                        v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                        class="save-btn"
                        type="button"
                        @click="saveProduto()"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
            <br />
            <div class="form-columns-fit page-container">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <v-input
                            v-model="produto.idproprodutoerp"
                            id="codigo"
                            :maxlength="50"
                            title="codigo"
                            msg="msg-campo-obrigatorio"
                            :invalid="!produto.idproprodutoerp"
                            ref="codigoInput"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <v-input
                            v-model="produto.descricao"
                            :id="'descricao'"
                            :placeholder="'descricao-do-produto-placeholder'"
                            :maxlength="50"
                            :title="'descricao-produto'"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!produto.descricao"
                            ref="descricaoInput"
                            :required="true"
                        />
                    </div>
                    <div class="column is-6">
                        <v-input
                            v-model="produto.codigobarra"
                            :id="'codigobarra'"
                            :placeholder="'codigo-barra-placeholder'"
                            :maxlength="50"
                            :title="'codigo-barra'"
                            ref="codigoBarraInput"
                            @input="onlyNumbersInner(produto.codigobarra)"
                            :onKeyUp="replaceLetters"
                            :onBlurFunction="onlyNumbersInner"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="
                                !onlyNumbersValidate ||
                                produto.codigobarra == '' ||
                                produto.codigobarra == null
                            "
                            :required="true"
                        />
                    </div>
                    <div class="column is-6">
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <vs-select
                                    ref="marcasSelect"
                                    :title="'produto-marca'"
                                    :options="marcas"
                                    v-model="marca"
                                    :search="loadMarca"
                                    :onChange="updateMarca"
                                    :focusin="loadAllMarcas"
                                    :keydown="tabSelectMarca"
                                    :placeholder="'descricao-da-marca-placeholder'"
                                    :invalid="marca == null"
                                    :required="true"
                                />
                            </div>
                            <div class="control padding-label padding-label-custom">
                                <b-button
                                    @click="isMarcaModalActive = true"
                                    icon-right="plus"
                                    v-tippy 
                                    :title="$t('nova-marca')"
                                />
                            </div>
                        </div>
                        <b-modal v-model="isMarcaModalActive">
                            <MarcaModal v-if="isMarcaModalActive" @fecharModal="fecharModal" />
                        </b-modal>
                    </div>
                    <div class="column is-6">
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <vs-select
                                    ref="gpSelect"
                                    :title="'produto-grupo-produto'"
                                    :options="grupos"
                                    v-model="grupo"
                                    :search="loadGrupo"
                                    :onChange="updateGrupo"
                                    :focusin="loadAllGrupos"
                                    :keydown="tabSelectGrupo"
                                    :placeholder="'grupo-do-sub-grupo-placeholder'"
                                    :invalid="grupo == null"
                                    :required="true"
                                />
                            </div>
                            <div class="control padding-label padding-label-custom">
                                <b-button
                                    @click="isGrupoProdutoModalActive = true"
                                    icon-right="plus"
                                    v-tippy 
                                    :title="$t('novo-grupo-produto')"
                                />
                            </div>
                        </div>
                        <b-modal v-model="isGrupoProdutoModalActive">
                            <GrupoProdutoModalPromotor
                                v-if="isGrupoProdutoModalActive"
                                @fecharModal="fecharModal"
                            />
                        </b-modal>
                    </div>
                    <div class="column is-6">
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <vs-select
                                    ref="subgrupoInput"
                                    :title="'produto-subgrupo-produto'"
                                    :options="subgrupos"
                                    v-model="subgrupo"
                                    :onChange="updateSubgrupo"
                                    :keydown="tabSelectSubGrupo"
                                    :focusin="loadSubGrupo"
                                    :loading="isLoadingSubGrupo"
                                    :placeholder="'sub-grupo-linha-placeholder'"
                                    :invalid="subgrupo == null"
                                    :disabled="grupo == null"
                                    :required="true"
                                />
                            </div>
                            <div class="control padding-label padding-label-custom">
                                <b-button
                                    @click="isSubGrupoProdutoModalActive = true"
                                    icon-right="plus"
                                    :disabled="grupo == null"
                                    v-tippy 
                                    :title="$t('novo-sub-grupo-produto')"
                                />
                            </div>
                        </div>
                        <b-modal v-model="isSubGrupoProdutoModalActive">
                            <SubGrupoProdutoModalPromotor
                                v-if="isSubGrupoProdutoModalActive"
                                @fecharModal="fecharModal"
                                :grupo="this.grupocadastrado ? this.grupocadastrado : this.grupo"
                            />
                        </b-modal>
                    </div>
                    <div class="column is-6">
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <vs-select
                                    ref="linhaprodutoInput"
                                    :title="'produto-linhaproduto'"
                                    :options="linhas"
                                    v-model="linha"
                                    :onChange="updateLinha"
                                    :focusin="loadLinha"
                                    :keydown="tabSelectLinha"
                                    :placeholder="'descricao-da-linha-placeholder'"
                                    :invalid="linha == null"
                                    :disabled="subgrupo == null"
                                    :required="true"
                                />
                            </div>
                            <div class="control padding-label padding-label-custom">
                                <b-button
                                    @click="isLinhaProdutoModalActive = true"
                                    icon-right="plus"
                                    :disabled="subgrupo == null"
                                    v-tippy 
                                    :title="$t('nova-linha-produto')"
                                />
                            </div>
                        </div>
                        <b-modal v-model="isLinhaProdutoModalActive">
                            <LinhaProdutoModalPromotor
                                v-if="isLinhaProdutoModalActive"
                                @fecharModal="fecharModal"
                                :gruposelected="this.grupocadastrado"
                                :subgruposelected="this.subgrupocadastrado"
                            />
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProProdutoService from '@/services/promotor/ProProdutoService';
import MarcaService from '@/services/MarcaService';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import LinhaProdutoService from '@/services/LinhaProdutoService';
import ProdutoValidation from '@/services/validations/ProdutoValidation';
import Message from '@/models/Message';
import MarcaModal from '@/components/promotor/marca/MarcaModal.vue';
import GrupoProdutoModalPromotor from '@/components/promotor/grupo-produto/modal/GrupoProdutoModalPromotor';
import SubGrupoProdutoModalPromotor from '@/components/promotor/subgrupo-produto/modal/SubGrupoProdutoModalPromotor';
import LinhaProdutoModalPromotor from '@/components/promotor/linha-produto/modal/LinhaProdutoModalPromotor';

export default {
    components: {
        MarcaModal,
        GrupoProdutoModalPromotor,
        SubGrupoProdutoModalPromotor,
        LinhaProdutoModalPromotor,
    },
    data() {
        return {
            isSaving: false,
            produto: {
                idproprodutoerp: null,
                situacao: 1,
                concorrente: 0,
                marca: null,
                grupoproduto: null,
                subgrupoproduto: null,
                linhaproduto: null,
            },
            editable: false,
            title: '',
            msgs: [],
            marca: null,
            marcas: [],
            grupo: null,
            grupocadastrado: {},
            subgrupocadastrado: {},
            grupos: [],
            subgrupo: null,
            subgrupos: [],
            linha: null,
            linhas: [],
            canSelectMarca: false,
            canSelectGrupo: false,
            canSelectSubGrupo: false,
            canSelectLinha: false,
            onlyNumbersValidate: true,
            isUpdate: false,
            isLoadingSubGrupo: false,
            isMarcaModalActive: false,
            isGrupoProdutoModalActive: false,
            isSubGrupoProdutoModalActive: false,
            isLinhaProdutoModalActive: false,
        };
    },
    created() {
        if (this.produto != null && this.produto != {}) {
            this.editable = true;
        }
        this.service = new ProProdutoService(this.$http, this.$router);
        this.marcaService = new MarcaService(this.$http, this.$router);
        this.grupoProdutoService = new GrupoProdutoService(this.$http, this.$router);
        this.subGrupoProdutoService = new SubGrupoProdutoService(this.$http, this.$router);
        this.linhaProdutoService = new LinhaProdutoService(this.$http, this.$router);
        this.validation = new ProdutoValidation(this.msgs);

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'produtos');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'produto' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'produto' },
                });
            }
            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
        this.loadAllMarcas();
    },
    methods: {
        getMax(array) {
            let max = Math.max.apply(
                Math,
                array.map((e) => {
                    return +e.id;
                })
            );
            let filtrado = array.filter((e) => e.id == max)[0];
            return Object.assign({}, filtrado);
        },
        fecharModal(val, action, situacao, linhacadastrada) {
            if (val == 'marca') {
                this.isMarcaModalActive = false;
                if (action == 'save' && situacao == 1) {
                    this.loadAllMarcas();
                    setTimeout((_) => {
                        this.marca = this.getMax(this.marcas);
                    }, 500);
                }
            } else if (val == 'grupo-produto') {
                this.isGrupoProdutoModalActive = false;
                if (action == 'save' && situacao == 1) {
                    this.loadAllGrupos();
                    this.updateSubgrupo();
                    setTimeout((_) => {
                        this.grupo = this.getMax(this.grupos);
                        this.grupocadastrado = this.getMax(this.grupos);
                    }, 500);
                }
            } else if (val == 'subgrupo-produto') {
                this.isSubGrupoProdutoModalActive = false;
                if (action == 'save' && situacao == 1) {
                    this.loadSubGrupo();
                    setTimeout((_) => {
                        this.subgrupo = this.getMax(this.subgrupos);
                        this.subgrupocadastrado = this.getMax(this.subgrupos);
                    }, 500);
                }
            } else if (val == 'linha-produto') {
                this.isLinhaProdutoModalActive = false;
                if (action == 'save' && situacao == 1) {
                    if (linhacadastrada) {
                        this.linha = {
                            id: linhacadastrada.id,
                            label: linhacadastrada.descricao,
                        };
                    }
                }
            }
        },
        replaceLetters() {
            //Aplica replace em todas as letras do campo codigo de barra
            this.produto.codigobarra = this.produto.codigobarra.replace(/([^\d])+/gim, '');
        },
        onlyNumbersInner() {
            if (this.produto.codigobarra && this.produto.codigobarra != '') {
                //Esta função exibe mensagem se não for numero, porém com o replace não sera exibido nada, mas fica de garantia.
                if (!this.onlyNumbers(this.produto.codigobarra)) {
                    this.onlyNumbersValidate = false;
                } else {
                    this.onlyNumbersValidate = true;
                }
            } else {
                this.onlyNumbersValidate = false;
            }
        },
        tabSelectMarca(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectMarca = true;
            if (e.code == 'Tab' && this.canSelectMarca) {
                this.$refs.marcasSelect.typeAheadSelect();
                this.$refs.marcasSelect.focus();
                this.canSelectMarca = false;
            }
        },
        tabSelectGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectGrupo = true;
            if (e.code == 'Tab' && this.canSelectGrupo) {
                this.$refs.gpSelect.typeAheadSelect();
                this.$refs.gpSelect.focus();
                this.canSelectGrupo = false;
            }
        },
        tabSelectSubGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectSubGrupo = true;
            if (e.code == 'Tab' && this.canSelectSubGrupo) {
                this.$refs.subgrupoInput.typeAheadSelect();
                this.$refs.subgrupoInput.focus();
                this.canSelectSubGrupo = false;
            }
        },
        tabSelectLinha(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectLinha = true;
            if (e.code == 'Tab' && this.canSelectLinha) {
                this.$refs.linhaprodutoInput.typeAheadSelect();
                this.$refs.linhaprodutoInput.focus();
                this.canSelectLinha = false;
            }
        },
        carregarDados(id) {
            this.service.find(id).then((body) => {
                if (body.content) {
                    this.produto = body.content;
                    if (this.produto.marca) {
                        this.marca = {
                            id: this.produto.marca.id,
                            label: this.produto.marca.descricao,
                        };
                    }
                    if (this.produto.grupoproduto) {
                        this.grupo = {
                            id: this.produto.grupoproduto.id,
                            label: this.produto.grupoproduto.descricao,
                        };
                    }
                    if (this.produto.subgrupoproduto) {
                        this.subgrupo = {
                            id: this.produto.subgrupoproduto.id,
                            label: this.produto.subgrupoproduto.descricao,
                        };
                    }
                    if (this.produto.linhaproduto) {
                        this.linha = {
                            id: this.produto.linhaproduto.id,
                            label: this.produto.linhaproduto.descricao,
                        };
                    }
                    this.title = this.produto.descricao;
                } else {
                    this.$router.push({ name: 'new-produto' });
                }
            });
        },

        loadAllMarcas() {
            this.marcaService
                .findAll(0, 10000, 1)
                .then(this.mapItems)
                .then((allbrands) => {
                    let marca = allbrands.filter((e) => this.marca && e.id == this.marca.id)[0];
                    if (this.marca && !marca) allbrands.push(this.marca);
                    this.marcas = allbrands;
                    this.marcas.sort(this.orderByLabelCombo);
                });
        },
        loadAllGrupos() {
            this.grupoProdutoService
                .findAllCombo('')
                .then(this.mapItems)
                .then((allgroups) => {
                    let grupo = allgroups.filter((c) => this.grupo && c.id == this.grupo.id)[0];
                    this.grupocadastrado = grupo;
                    if (this.grupo && !grupo) allgroups.push(this.grupo);
                    this.grupos = allgroups;
                    this.grupos.sort(this.orderByLabelCombo);
                }, 350);
        },
        loadMarca(search, loading) {
            loading(true);
            this.marcaService
                .findAll(0, 100000, 1, search)
                .then(this.mapItems)
                .then((allbrands) => {
                    this.marcas = allbrands;
                    loading(false);
                }, 350);
        },
        loadGrupo(search, loading) {
            this.grupoProdutoService
                .findAllCombo(search)
                .then(this.mapItems)
                .then((allgroups) => {
                    this.grupos = allgroups;
                    loading(false);
                }, 350);
        },
        loadSubGrupo() {
            this.isLoadingSubGrupo = true;
            this.subGrupoProdutoService
                .findByGroup(0, 100000, this.grupo.id)
                .then(this.mapItems)
                .then((allsubgroups) => {
                    this.subgrupos = allsubgroups;
                    if (this.subgrupo != null) {
                        let subgrupo = this.subgrupos.filter((c) => c.id == this.subgrupo.id)[0];
                        this.subgrupocadastrado = subgrupo;
                        if (this.subgrupo.id && !subgrupo) {
                            this.subgrupos.push(this.subgrupo);
                        }
                        this.updateSubgrupo(
                            this.subgrupos.filter((sg) => sg.id == this.subgrupo.id)[0]
                        );
                    } else {
                        this.updateSubgrupo();
                    }
                    this.subgrupos.sort(this.orderByLabelCombo);
                    this.isLoadingSubGrupo = false;
                }, 350);
        },
        loadLinha() {
            this.linhaProdutoService
                .findByGrupoAndSubgrupo(0, 100000, this.grupo.id, this.subgrupo.id)
                .then(this.mapItems)
                .then((alllines) => {
                    this.linhas = alllines;
                    let li = this.linhas.filter((c) => c.id == this.grupo.id)[0];
                    if (
                        !li &&
                        this.subgrupo &&
                        this.subgrupo != null &&
                        this.subgrupo.id == this.linha.id
                    ) {
                        this.linhas.push(this.linha);
                        this.updateLinha(this.linhas.filter((l) => l.id == this.linha.id)[0]);
                    } else {
                        this.updateLinha();
                    }
                    this.linhas.sort(this.orderByLabelCombo);
                }, 350);
        },

        updateMarca(marca) {
            this.marca = marca ? marca : null;
        },
        updateGrupo(gp) {
            if (gp) {
                if (this.grupo && gp.id != this.grupo.id) this.subgrupo = null;
                this.grupo = gp;
                this.grupocadastrado = gp;
            } else {
                this.grupo = null;
                this.subgrupo = null;
            }
            this.updateSubgrupo();
        },
        updateSubgrupo(sgp) {
            let updateLinha = false;
            if (sgp) {
                if (this.subgrupo && sgp.id != this.subgrupo.id) updateLinha = true;
                this.subgrupo = sgp;
                this.subgrupocadastrado = sgp;
            } else {
                updateLinha = true;
                this.subgrupo = null;
            }
            if (updateLinha) this.linha = null;
        },
        updateLinha(linha) {
            this.linha = linha ? linha : null;
        },

        mapItems(body) {
            let grupolist = body.content.map((r) => {
                return {
                    id: r.id,
                    label: r.descricao,
                };
            });
            return grupolist;
        },
        saveProduto() {
            this.produto.marca =
                this.marca != null
                    ? { idmarca: this.marca.id, id: this.marca.id, descricao: this.marca.label }
                    : null;
            this.produto.grupoproduto =
                this.grupo != null
                    ? {
                          idgrupoproduto: this.grupo.id,
                          id: this.grupo.id,
                          descricao: this.grupo.label,
                      }
                    : null;
            this.produto.subgrupoproduto =
                this.subgrupo != null
                    ? {
                          idsubgrupoproduto: this.subgrupo.id,
                          id: this.subgrupo.id,
                          descricao: this.subgrupo.label,
                      }
                    : null;
            this.produto.linhaproduto =
                this.linha != null
                    ? {
                          idlinhaproduto: this.linha.id,
                          id: this.linha.id,
                          descricao: this.linha.label,
                      }
                    : null;

            if (this.validation.validate(this.produto, this.$refs)) {
                this.produto = this.mapTosave(this.produto);
                this.isSaving = true;
                this.service
                    .save(this.produto)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-produto-salvo';
                            if (this.produto.id) {
                                msg = 'msg-produto-editado';
                            }
                            this.produto = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToList(2);
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'pro-produto-list',
                });
            }, time * 1000 + 50);
        },
        redirectToPage() {
            if (this.$route.query.tela == 'empresa-produto') {
                setTimeout(() => {
                    this.$router.push({
                        name: 'pro-empresa-dados-cadastrais-edit',
                        params: {
                            id: this.$route.query.id,
                        },
                    });
                }, 1000);
            } else {
                setTimeout(() => {
                    this.$router.push({
                        name: 'pro-produto-list',
                    });
                }, 1000);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
</style>
